import React$1 from 'react';
import PropTypes$1 from 'prop-types';
import { useValue } from '@morningtrain/react-resources';
import { observer } from 'mobx-react';

function Link(props) {
  var name = props.name,
      defaultValue = props.defaultValue;
  var value = useValue(name, defaultValue);
  var label = props.label || value;

  if (React$1.Children.count(props.children) > 0) {
    label = props.children;
  }

  return /*#__PURE__*/React$1.createElement("a", {
    href: value,
    target: props.target,
    className: props.className,
    title: props.title,
    alt: props.alt
  }, label);
}

Link.defaultProps = {
  defaultValue: null,
  className: '',
  target: '_blank',
  alt: null,
  title: null,
  label: null
};
Link.propTypes = {
  name: PropTypes$1.string.isRequired,
  defaultValue: PropTypes$1.any,
  className: PropTypes$1.string,
  target: PropTypes$1.oneOf(['_blank', '_self', '_parent', '_top']),
  alt: PropTypes$1.string,
  title: PropTypes$1.string,
  label: PropTypes$1.node
};
var Link$1 = observer(Link);

export default Link$1;
//# sourceMappingURL=Link.js.map
